import React from 'react';
import { injectIntl } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import AttachmentList from './AttachmentList';

const { UUID } = sdkTypes;

const attachment = (id, name, size, state) => ({
  id: new UUID(`fa-${id}`),
  type: 'fileAttachment',
  attributes: { scope: 'protected', deleted: false },
  file: {
    id: new UUID(`f-${id}`),
    type: 'file',
    attributes: { name, size, state, deleted: false },
  },
});

// The list needs the intl object as a prop, so wrap it for the styleguide.
const List = injectIntl(props => (
  <AttachmentList
    onDownloadAttachment={(id, name) => console.log('download', id, name)}
    downloadAttachmentInProgressIds={[]}
    onOpenAttachment={(id, name) => console.log('open', id, name)}
    onFetchAttachmentPreview={id => console.log('preview', id)}
    attachmentPreviewUrls={{}}
    {...props}
  />
));

// Every card state at once: downloadable PDF and image, scanning, failed.
export const Mixed = {
  component: List,
  props: {
    attachments: [
      attachment('a', 'tarjous.pdf', 245760, 'available'),
      attachment('b', 'luonnos.png', 1048576, 'available'),
      attachment('c', 'lahdetiedostot.zip', 15728640, 'pendingVerification'),
      attachment('d', 'skripti.sh', 512, 'verificationFailed'),
    ],
  },
  group: 'transaction',
};
